import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import { SideNavOuterToolbarModule, SingleCardModule } from './layouts';
import { FooterModule, HeaderModule, LoginFormModule } from './shared/components';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { LoaderComponent } from './layouts/loader/loader.component';
import { AuthInterceptorService } from './shared/services/auth-interceptor.service';
import { CoreModule } from './core/core.module';
import { DxPopupModule, DxScrollViewModule, DxFormModule, DxTextAreaModule, DxDataGridModule, DxButtonModule } from 'devextreme-angular';
import { APIConfingService } from './shared/services/apiconfing.service';
import { PublicHeaderModule } from './shared/components/public-header/public-header.component';
import { ToastrModule, ToastNoAnimation, ToastNoAnimationModule, ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PublicFooterModule } from './shared/components/public-footer/public-footer.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SignInModule } from './core/component/sign-in/sign-in.module';
import { RegisterFormModule } from './shared/components/register-form/register-form.component';
import { enableProdMode } from "@angular/core";
import { environment as settingsENV } from '../../projects/public/src/environments/public-app.environment';
import { AccessDeniedComponent } from './layouts/access-denied/access-denied.component';
import { licenseKey } from '../devextreme-license';
import config from 'devextreme/core/config';

config({
  licenseKey: licenseKey,
})
// import { PublicReferAFriendComponent } from './public/public-refer-a-friend/public-refer-a-friend.component';
// import { PasswordChangeComponent } from './shared/components/password-change/password-change.component';
// import { PublicOnboardInitiateApprovalComponent } from './public/public-onboard-initiate-approval/public-onboard-initiate-approval.component';

// Sentry.init({
//   dsn: "https://aaa728c9507d471ba7060d78fe9af37d@o4504162443591680.ingest.sentry.io/4504162451587072",
//   integrations: [
//     new BrowserTracing({
//       tracingOrigins: ["https://self.staffinggo.in", "https://emp.staffinggo.in", "https://css.easybillnpay.com", "https://qaess.staffinggo.in"],
//       routingInstrumentation: Sentry.routingInstrumentation,
//     }),
//   ],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 0.5,
// });

settingsENV.standalone = false;
enableProdMode();


export function APIConfigurations(configService: APIConfingService) {
  return () => configService.loadAPIConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    AccessDeniedComponent
    // PublicReferAFriendComponent,
    // PasswordChangeComponent,
    // PublicOnboardInitiateApprovalComponent,
    // PublicOfferApprovalComponent,
    // PublicResignApprovalComponent,
    // PublicLoanApplyComponent,
    //  CommonReimbursementPerquisiteFormComponent,
    // CommonReimbursementPerquisiteComponent,
    // TrackMeComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SideNavOuterToolbarModule,
    SignInModule,
    SingleCardModule,
    FooterModule,
    LoginFormModule,
    RegisterFormModule,
    AppRoutingModule,
    HttpClientModule,
    CoreModule,
    DxPopupModule,
    DxScrollViewModule,
    DxFormModule,
    DxButtonModule,
    PublicHeaderModule,
    PublicFooterModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true,
      progressAnimation: 'decreasing',
      countDuplicates: true,
      resetTimeoutOnDuplicate: true,
      tapToDismiss: false,
      enableHtml: true
    }),
    NgxSpinnerModule,
    AngularEditorModule,
    DxTextAreaModule,
    DxDataGridModule,
  ],
  exports: [],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }
    , AuthService
    , ScreenService
    , AppInfoService
    , CookieService
    , ToastrService
    , {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [APIConfingService],
    useFactory: APIConfigurations,
  },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: EncryptDecryptAuthInterceptor,
    //   multi: true
    // },
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => { },
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }

// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .catch(err => console.error(err));
